// src/router/config.ts
const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/pricing",
    exact: true,
    component: "Pricing",
  },
  {
    path: "/about",
    exact: true,
    component: "About",
  },
  {
    path: "/security",
    exact: true,
    component: "Security",
  },
  {
    path: "/demo",
    exact: true,
    component: "Demo",
  },
  {
    path: "/terms",
    exact: true,
    component: "Terms",
  },
  {
    path: "/privacy",
    exact: true,
    component: "Privacy",
  },
];

export default routes;